import { useRSimsSims } from 'rSimInventory/hooks/useRSimsSims';
import { RSimInventoryItem } from 'src/rSimInventory/constants/rsim';
import { rSimsSimsContext } from 'src/rSimInventory/Components/Providers/RSimsSimsContext';

type RSimsSimsProviderProps = {
  children: React.ReactNode;
  rsims?: RSimInventoryItem[];
};

export const RSimsSimsProvider = ({ rsims, children }: RSimsSimsProviderProps) => {
  const data = useRSimsSims(rsims);

  return <rSimsSimsContext.Provider value={{ data }}>{children}</rSimsSimsContext.Provider>;
};
